var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h

  return _c(
    "div",
    {
      staticClass: "pt-4"
    },
    [
      _c(
        "gg-card",
        [
          _c("gg-card-header", [_vm._v(" Change Security Questions ")]),
          _c(
            "gg-card-text",
            [
              _c(
                "gg-loading",
                {
                  attrs: {
                    loading: !_vm.questionsLoaded
                  }
                },
                [
                  !_vm.isSaved
                    ? _c("edit-questions", {
                        attrs: {
                          questions: _vm.questionsList,
                          loading: _vm.loading
                        },
                        on: {
                          save: _vm.saveAnswers
                        }
                      })
                    : _c("saved-questions", {
                        attrs: {
                          questions: _vm.savedQuestions
                        },
                        on: {
                          change: _vm.changeQuestions
                        }
                      })
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }